// extracted by mini-css-extract-plugin
module.exports = {"video-block":"VideoBlock_video-block__7IW3Z","videoBlock":"VideoBlock_video-block__7IW3Z","no-margins":"VideoBlock_no-margins__YVJMA","noMargins":"VideoBlock_no-margins__YVJMA"};